import moment from 'moment-timezone';

export function dateTimeFormat(date) {
  if (date == null || date === '') {
    return '--';
  }
  return moment.utc(date).tz('Africa/Kampala').format('DD-MM-YYYY HH:mm:ss');
}
